import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_pay_workers_correctly_during_work_stoppages'

export const dataPointDefinition = {
  retracedId: 'does_facility_pay_workers_correctly_during_work_stoppages',
  name: 'Does the facility pay workers correctly during work stoppages in line with legal requirements?',
  description: 'The intent of this question is to understand if the facility pays as required during work stoppages. ',
  meta: {
    slcpMeta: {
      key: 'wb-25',
      number: 'WB-WAGE-152',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-25', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35450,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
